<script lang="ts" setup>
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
	Input,
	SingleSelectList,
	SingleSelectListItem,
} from '@laam/ui/base';

import CustomTrouserFigure from './CustomTrouserFigure.vue';
import { useField } from 'vee-validate';

interface CustomTrouserProps {
	customTrouser: {
		[key: string]: string;
	};
}
const props = defineProps<CustomTrouserProps>();

const units = useField<string | undefined>('unitsTrouser').value;
const trouserLengthHighlighted = ref(false);
const waistHighlighted = ref(false);
const thighHighlighted = ref(false);
const kneeHighlighted = ref(false);
const bottomHighlighted = ref(false);
const hipHighlighted = ref(false);
// trouser added In prefix to avoid clashing with shirt element ids, do not change

const trouserLength = computed(() => {
	return props.customTrouser['Trouser Length'];
});

const trouserWaistLength = computed(() => {
	return props.customTrouser['Trouser Waist'];
});
const trouserThighLength = computed(() => {
	return props.customTrouser['Trouser Thigh'];
});
const trouserKneeLength = computed(() => {
	return props.customTrouser['Trouser Knee'];
});
const trouserBottomLength = computed(() => {
	return props.customTrouser['Trouser Bottom'];
});
const trouserHipLength = computed(() => {
	return props.customTrouser['Trouser Hip'];
});

function sendval(e: { target: { id: any; value: any } }) {
	console.log(e.target.id, e.target.value, units);
	// setprops.CustomTrouser(e.target.id, e.target.value, units);
}
</script>

<template>
	<div class="size-chart__custom-trouser-form">
		<div class="pb-lg flex items-center justify-between">
			<span class="block text-2xl font-medium">Trouser</span>
			<FormField v-slot="{ componentField }" name="unitsTrouser">
				<FormItem>
					<FormControl>
						<SingleSelectList
							v-bind="componentField"
							class="grid grid-cols-2"
							default-value="Cm"
						>
							<SingleSelectListItem value="Cm"> Cm </SingleSelectListItem>
							<SingleSelectListItem value="In"> In </SingleSelectListItem>
						</SingleSelectList>
					</FormControl>
				</FormItem>
			</FormField>
		</div>

		<div class="">
			<CustomTrouserFigure
				:custom-trouser="props.customTrouser"
				:trouser-length-highlighted="trouserLengthHighlighted"
				:waist-highlighted="waistHighlighted"
				:thigh-highlighted="thighHighlighted"
				:knee-highlighted="kneeHighlighted"
				:bottom-highlighted="bottomHighlighted"
				:hip-highlighted="hipHighlighted"
			/>

			<div class="-mx-3xl border-b border-gray-200 border-solid"></div>

			<div class="py-3xl gap-xl component--trouserform flex flex-col w-full">
				<FormField v-slot="{ componentField }" name="trouserLength">
					<FormItem class="form-item">
						<FormLabel for="Trouser Length" class="form-label">
							Trouser Length({{ units }})
						</FormLabel>
						<FormControl>
							<Input
								v-bind="componentField"
								id="Trouser Length"
								v-model="trouserLength"
								type="number"
								name="trouserLength"
								class="form-input"
								required
								@focus="trouserLengthHighlighted = true"
								@blur="trouserLengthHighlighted = false"
								@input="sendval"
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				</FormField>

				<FormField v-slot="{ componentField }" name="trouserWaistLength">
					<FormItem class="form-item">
						<FormLabel for="Trouser Waist" class="form-label">
							Waist({{ units }})
						</FormLabel>
						<FormControl>
							<Input
								v-bind="componentField"
								id="Trouser Waist"
								v-model="trouserWaistLength"
								type="number"
								name="trouserWaistLength"
								class="form-input"
								required
								@focus="waistHighlighted = true"
								@blur="waistHighlighted = false"
								@input="sendval"
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				</FormField>

				<FormField v-slot="{ componentField }" name="trouserHipLength">
					<FormItem class="form-item">
						<FormLabel for="Trouser Hip" class="form-label">
							Hip({{ units }})
						</FormLabel>

						<FormControl>
							<Input
								v-bind="componentField"
								id="Trouser Hip"
								v-model="trouserHipLength"
								type="number"
								name="trouserHipLength"
								class="form-input"
								required
								@focus="hipHighlighted = true"
								@blur="hipHighlighted = false"
								@input="sendval"
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				</FormField>

				<FormField v-slot="{ componentField }" name="trouserThighLength">
					<FormItem class="form-item">
						<FormLabel for="Trouser Thigh" class="form-label">
							Thigh({{ units }})
						</FormLabel>
						<FormControl>
							<Input
								v-bind="componentField"
								id="Trouser Thigh"
								v-model="trouserThighLength"
								type="number"
								name="trouserThighLength"
								class="form-input"
								required
								@focus="thighHighlighted = true"
								@blur="thighHighlighted = false"
								@input="sendval"
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				</FormField>

				<FormField v-slot="{ componentField }" name="trouserKneeLength">
					<FormItem class="form-item">
						<FormLabel for="Trouser Knee" class="form-label">
							Knee({{ units }})
						</FormLabel>
						<FormControl>
							<Input
								v-bind="componentField"
								id="Trouser Knee"
								v-model="trouserKneeLength"
								type="number"
								name="trouserKneeLength"
								class="form-input"
								required
								@focus="kneeHighlighted = true"
								@blur="kneeHighlighted = false"
								@input="sendval"
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				</FormField>

				<FormField v-slot="{ componentField }" name="trouserBottomLength">
					<FormItem class="form-item">
						<FormLabel for="Trouser Bottom" class="form-label">
							Bottom({{ units }})
						</FormLabel>
						<FormControl>
							<Input
								v-bind="componentField"
								id="Trouser Bottom"
								v-model="trouserBottomLength"
								type="number"
								name="trouserBottomLength"
								class="form-input"
								required
								@focus="bottomHighlighted = true"
								@blur="bottomHighlighted = false"
								@input="sendval"
							/>
						</FormControl>
						<FormMessage />
					</FormItem>
				</FormField>
			</div>
		</div>
	</div>
</template>

<style>
.form-item {
	@apply flex flex-col gap-sm;
}

.form-label {
	@apply font-normal text-gray-800 text-start;
}

.form-input {
	@apply border block w-full appearance-none rounded  border-solid border-[#C6C6C6] bg-transparent px-lg py-md  text-sm font-normal text-[#888888] valid:border-green-500 focus:border-rose-600 focus:outline-none focus:ring-0;
}
</style>
